import { ContentPage } from '../page-factory/content-page';
import { basantPanchamiPage } from '../pages/page-magh-mela.bathing-dates';
import { MetaFunction } from '@remix-run/cloudflare';

export const meta: MetaFunction = () => {
  return [
    { title: 'Basant Panchami - Magh Mela 2026 - Kumbh Sukrit' },
    {
      name: 'description',
      content:
        'Celebrate Basant Panchami at Magh Mela 2026. Welcome spring and seek blessings of Goddess Saraswati with Kumbh Sukrit.',
    },
    {
      tagName: 'link',
      rel: 'canonical',
      href: 'https://kumbhsukrit.com/magh-mela-2026/basant-panchami',
    },
  ];
};

export default function BasantPanchamiPage() {
  return <ContentPage {...basantPanchamiPage} />;
}
